import { action, makeObservable } from 'mobx';

import { ProductConfigurationData, ShoppingContext } from '../../data/model';
import { ConfiguratorUrlBuilder } from '../../errorHandling/ParseConfigurationCodeAndRedirectState';
import { Analytics } from '../../shared/analytics/Analytics';
import { AsyncCommand } from '../../shared/common';
import { INavigationService } from '../../shared/NavigationService';

export class GoToConfiguratorActionState {
  private context: ShoppingContext;
  public readonly goToConfiguratorCommand: AsyncCommand;

  constructor(
    private readonly navigation: INavigationService,
    private readonly code: string,
    private readonly configuration: ProductConfigurationData,
  ) {
    makeObservable(this);
    this.code = code;
    this.goToConfiguratorCommand = new AsyncCommand(() => this.goToConfigurator());
  }

  initialize(context: ShoppingContext) {
    this.context = context;
  }

  @action
  public async goToConfigurator(): Promise<void> {
    Analytics.trackConfigureClick(this.context);

    const configuratorUrl = ConfiguratorUrlBuilder.buildFromConfiguration(this.code, this.configuration);
    this.navigation.navigateTo(configuratorUrl);
  }
}
